import React, { useState } from 'react';
import styled from 'styled-components';
import { FaPhone, FaEnvelope, FaHandHoldingHeart } from 'react-icons/fa';
import { HiLocationMarker } from 'react-icons/hi';

const HeaderContainer = styled.header`
  background-color: #000000;
  color: white;
  font-family: 'Poppins', sans-serif;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 2rem;
  }
`;

const ContactToggle = styled.button`
  background: transparent;
  border: none;
  color: white;
  font-size: 0.9rem;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  
  &::after {
    content: '${props => props.isOpen ? '−' : '+'}';
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const ContactInfo = styled.div`
  display: ${props => props.isOpen || props.isDesktop ? 'flex' : 'none'};
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: ${props => props.isDesktop ? '0' : '0.75rem'};
  width: 100%;
  
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 1.5rem;
    margin-bottom: 0;
  }
`;

const ContactItem = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ContactLink = styled.a`
  color: white;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    color: #f8f8f8;
    text-decoration: underline;
  }
`;

const DonateLink = styled.a`
  background-color: #f7941d;
  color: white;
  font-weight: 600;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  text-decoration: none;
  
  &:hover {
    background-color: #7a9426;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    color: white;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (min-width: 768px) {
    width: auto;
    min-width: 150px;
  }
`;

const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 0.4rem;
  font-size: 0.9rem;
  
  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const Header = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const isDesktop = typeof window !== 'undefined' ? window.innerWidth >= 768 : false;

  return (
    <HeaderContainer>
      <HeaderContent>
        <div>
          <ContactToggle 
            isOpen={isContactOpen} 
            onClick={() => setIsContactOpen(!isContactOpen)}
            aria-expanded={isContactOpen}
            aria-controls="contact-info"
          >
            Contact Information
          </ContactToggle>
          
          <ContactInfo id="contact-info" isOpen={isContactOpen} isDesktop={isDesktop}>
            <ContactItem>
              <Icon><HiLocationMarker /></Icon>
              233-237 Roundhay Road, Leeds, LS8 4HS
            </ContactItem>
            <ContactItem>
              <Icon><FaPhone /></Icon>
              <ContactLink href="tel:01133805630">0113 3805630</ContactLink>
            </ContactItem>
            <ContactItem>
              <Icon><FaEnvelope /></Icon>
              <ContactLink href="mailto:info@retasleeds.org.uk">info@retasleeds.org.uk</ContactLink>
            </ContactItem>
          </ContactInfo>
        </div>
        
        <DonateLink href="https://localgiving.org/charity/retasleeds">
          <FaHandHoldingHeart />
          Donate Now
        </DonateLink>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
